import { observer } from 'mobx-react-lite'

import { Form } from 'components/uiKit'

import { CompanyDetailsViewModel } from '../../../stores/models/CompanyDetailsViewModel'
import { PassportPhoto } from './PassportPhoto'

type PassportPhotoStepProps = {
  companyDetails: CompanyDetailsViewModel
  isEdit?: boolean
}

export const PassportPhotoStep = observer(({ companyDetails, isEdit = false }: PassportPhotoStepProps) => {
  return (
    <Form style={{ maxWidth: 600, marginTop: 50 }}>
      <PassportPhoto companyDetails={companyDetails} isEdit={isEdit} />
    </Form>
  )
})
